import React, { useState, useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
NoDataToDisplay(Highcharts);

const HighchartBarChart = (props) => {
    const { chartOptions, seriesData = [], seriesName = null } = props;
    const [updatedChartOptions, setUpdatedChartOptions] = useState({
        ...chartOptions,
        lang: {
            noData: 'No data to display',
        },
        noData: {
            style: {
                fontWeight: 'bold',
                fontSize: '15px',
                color: '#303030',
            },
        },
        series: seriesName ? 
        [
            {
                name: seriesName,
                data: [...seriesData],
            }
        ]: seriesData?.map((series) => {
            let { name, data } = series; 
            return {
              name: name,
              data: [...data],
            };
          })
    });

    useEffect(() => {
        setUpdatedChartOptions({
            ...chartOptions,
            lang: {
                noData: 'No data to display',
            },
            noData: {
                style: {
                    fontWeight: 'bold',
                    fontSize: '15px',
                    color: '#303030',
                },
            },
            series: seriesName ? 
            [
                {
                    name: seriesName,
                    data: [...seriesData],
                }
            ]: [...seriesData],
        });
    }, [chartOptions, seriesData]);

    return (
        <HighchartsReact
            containerProps={{ id: 'container', style: { height: 'auto', width: '100%' } }}
            highcharts={Highcharts}
            options={updatedChartOptions}
        />
    );
};

export default HighchartBarChart;
